<script setup lang="ts">
definePage({
  name: 'protected',
});
</script>

<template>
  <div>
    <h1>Protected Page</h1>
  </div>
</template>
